import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FinancingPreferenceValue } from '../../../../../../api/types';

const useFinancingPreferenceOptions = () => {
    const { t } = useTranslation('moduleDetails');

    return useMemo(
        () => [
            {
                value: FinancingPreferenceValue.Mandatory,
                label: t('moduleDetails:explanations.financingPreference.mandatory'),
            },
            {
                value: FinancingPreferenceValue.Optional,
                label: t('moduleDetails:explanations.financingPreference.optional'),
            },
            {
                value: FinancingPreferenceValue.Request,
                label: t('moduleDetails:explanations.financingPreference.request'),
            },
        ],
        [t]
    );
};

export default useFinancingPreferenceOptions;
